
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': '项目 Gemini',
	'appExit': '转至欢迎页面',


	'widgetsListLabel': '窗口小部件列表。选择窗口小部件，然后按 Enter 键以添加。',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': '最新',
	'dirty': '非最新',
	'conflict': '保存视图时发生冲突',
	'error': '保存视图时发生问题',
	'failure': '无法联系服务器',
	'saveFailed': '无法保存视图',

	'wa_insync': '已保存',
	'wa_conflict': '保存视图时发生冲突',
	'wa_error': '无法保存视图',
	'wa_failure': '无法联系服务器',

	// Menu Labels
	'changeDisplay': '更改显示',
	'changeToColumnChart': '更改为柱形图',
	'changeToBubbleChart': '更改为气泡图',
	'toggleMoveHandles': '切换移动手柄',
	'undo': '撤销',
	'redo': '重做',
	'mode': '更改方式',

	'untitled': '无标题',
	'remove': '移除',
	'editTitle': '编辑标题',
	'edit': '编辑',
	'done': '完成',

	// Data tray
	'dataTrayHandleOpenLabel': '打开数据托盘',
	'dataTrayHandleCloseLabel': '关闭数据托盘',

	// Dialogs
	'dlg_loading': '正在装入...',
	'dlg_ok': '确定',
	'dlg_create': '创建',
	'dlg_cancel': '取消',
	'dlg_close': '关闭',
	'dlg_update': '更新',
	'dlg_renameBoardTitle': '重命名此对象',
	'dlg_renameDatasetTitle': '重命名此数据集',
	'dlg_renameSceneTitle': '重命名此场景',
	'dlg_NameLabel': '名称：',
	'dlg_NewNameLabel': '新建名称：',
	'dlg_DefaultNameWithDataSet': '%{name} 视图',
	'dlg_ShareTitle': '共享内容',
	'dlg_UnshareTitle': '移除内容共享',
	'dlg_ShareUser': '用户标识：',
	'dlg_NewColumnLabel': '新建计算名称',

	'dlg_new': '新建...',
	'dlg_open': '打开...',
	'dlg_makeACopy': '制作副本',
	'dlg_rename': '重命名...',
	'dlg_moreToCome': '更多操作...',

	'dlg_use': '使用',

	'dlg_RelinkDatasetTitle': '将数据集“%{datasetName}”替换为...',

	'open_error': '打开视图时发生问题。',

	// Delete Board
	'del_dialogTitle': '确认删除',
	'del_itemMsg': '确定要删除“%{name}”吗？',
	'del_itemsMsg': '确定要删除 %{count} 项吗？',
	'del_deleteErr': '无法删除“%{name}”',

	// List Sorting
	'dlg_ascending': '升序',
	'dlg_descending': '降序',
	'dlg_custom': '自定义',
	'dlg_none': '无',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': '搜索',

	'searchHint': '搜索所有数据',
	'clearSearchResult': '清除搜索结果',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': '圆圈',
	'shapesHexagon': '六角形',
	'shapesLine': '直线',
	'shapesOctagon': '八角形',
	'shapesPentagon': '五角形',
	'shapesSquare': '正方形',
	'shapesTriangle': '三角形',
	'shapesDiamond': '菱形',
	'shapesTitle': '形状属性', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': '圆角正方形',
	'shapesStar': '星形',
	'shapesChevron': 'V 形',
	'shapesBadge_ribbon': '角标功能区',
	'shapesBadge': '角标',
	'shapesHeart': '心形',
	'shapesExclamation': '惊叹号',
	'shapesTrendingup': '上升趋势',
	'shapesTrendingdown': '下降趋势',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': '人员',
	'shapesFemale': '女性',
	'shapesHappyface': '笑脸',
	'shapesMale': '男性',
	'shapesMan': '男人',
	'shapesNeutralface': '平静脸',
	'shapesSadface': '悲伤脸',
	'shapesShakehands': '握手',
	'shapesThumbsdown': '不赞成',
	'shapesThumbsup': '赞成',
	'shapesWoman': '女人',

	// Weather and places
	'shapesPlacesWeatherCat': '位置与天气',
	'shapesCity': '城市',
	'shapesCloud': '云',
	'shapesEducation': '教育',
	'shapesGovernment': '政府',
	'shapesHalfcloud': '半云形',
	'shapesHouse': '房屋形',
	'shapesMoon': '新月形',
	'shapesRain': '雨点',
	'shapesSunny': '阳光',

	//Vehicles
	'shapesVehiclesCat': '车辆',
	'shapesAirplane': '飞机',
	'shapesCar': '汽车',
	'shapesShip': '船',
	'shapesShoppingcart': '购物车',
	'shapesTrain': '火车',
	'shapesTruck': '卡车',

	//Objects
	'shapesObjectsCat': '对象数',
	'shapesBook': '书籍',
	'shapesBriefcase': '公文包',
	'shapesCalendar': '日历',
	'shapesCheck': '支票',
	'shapesClock': '时钟',
	'shapesDesktop': '台式机',
	'shapesDocument': '文档',

	'shapesFood': '食品',
	'shapesGear': '齿轮',
	'shapesHealth': '健康',

	'shapesIdea': '观点',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': '帐单',
	'shapesMoney_coin': '硬币',
	'shapesPiggybank': '存钱罐',
	'shapesStackofpaper': '纸堆',
	'shapesStickynote1': '即时贴 1',
	'shapesStickynote2': '即时贴 2',
	'shapesTarget': '目标',
	'shapesTool': '工具',

	'shapesUmbrella': '雨伞',

	'shapesBrain': '大脑',
	'shapesSkull': '头骨',
	'shapesEye': '眼睛',

	// Arrows shapes
	'shapesArrowsCat': '箭头',
	'shapesRightArrow': '向右箭头',
	'shapesLeftArrow': '向左箭头',
	'shapesDoubleArrow': '双箭头',
	'shapesCurvedArrow': '弯箭头',

	// Callouts shapes
	'shapesCalloutsCat': '标注',
	'shapesRectCallout': '标注',

	// Images
	'imagesCat': '图像',
	'imageWidgetTitle': '图像窗口小部件',
	'imgUrl': '图像 URL',
	'noImgSelected': '未选择图像',
	'enterImgUrl': '在此处输入图像 URL',
	'imgPasteLink': '粘贴 URL 并按 Enter 键以保存。',
	'imgResizeToFit': '调整大小以适合图像大小',
	'imgHeight': '高度：',
	'imgWidth': '宽度：',
	'imgTransparency': '透明度：',
	'imgMissingUrl': '缺少图像 URL。',
	'imgUrlValidationError': '图像 URL 无效。',
	'imgUrlInvalidDomainError': '图像 URL 指向尚未由管理员核准的域。管理员核准的域为“%{domains}”。',

	// line shape
	'propStrokeWidth': '线宽度',
	'propStrokeDashArray': '线样式',
	'propStrokeSolidline': '实线',
	'propStrokeLineCap': '线上限',
	'propStrokeLineCapButt': '对接',
	'propStrokeLineCapRound': '圆形',
	'propStrokeLineCapSquare': '正方形',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': '播放',
	'dataPlayerValueListLabel': '数据播放器值',
	// Text Widget
	'textWidgetTitle': '文本小窗口部件',
	'textStyle': '样式',
	'textStyleDescription': '预先设置格式的文本样式',
	'textTitleStyle': '标题',
	'textTitleSmallStyle': '标题（小）',
	'textSubtitleStyle': '副标题',
	'textBodyStyle': '正文',
	'textBodySmallStyle': '正文（小）',
	'textCaptionStyle': '标题',
	'textQuoteStyle': '引用',
	'textQuoteSmallStyle': '引用（小）',
	'textResponsiveStyle': '自动调整大小',
	'textAutoFontSize': '自动',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': '细线',
	'textFontFamilySubClassThin': '细',
	'textFontFamilySubClassThinItalic': '细斜体',
	'textFontFamilySubClassExtraLight': '超细体',
	'textFontFamilySubClassExtraLightItalic': '超细斜体',
	'textFontFamilySubClassLight': '标准细体',
	'textFontFamilySubClassLightItalic': '细斜体',
	'textFontFamilySubClassRegular': '普通',
	'textFontFamilySubClassRegularItalic': '普通斜体',
	'textFontFamilySubClassItalic': '斜体',
	'textFontFamilySubClassMedium': '中',
	'textFontFamilySubClassMediumItalic': '中斜体',
	'textFontFamilySubClassHeavy': '重',
	'textFontFamilySubClassHeavyItalic': '重斜体',
	'textFontFamilySubClassDemiBold': '半粗体',
	'textFontFamilySubClassDemiBoldItalic': '半粗斜体',
	'textFontFamilySubClassBold': '粗体',
	'textFontFamilySubClassBoldItalic': '粗斜体',
	'textFontFamilySubClassExtraBold': '超粗体',
	'textFontFamilySubClassExtraBoldItalic': '超粗斜体',
	'textFontFamilySubClassBlack': '黑色',
	'textFontFamilySubClassBlackItalic': '黑斜体',
	'textFontFamilySubClassStencil': '镂刻体',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': '自动调整字体大小',
	'responsiveCoachmarkContents': '当您重新调整此文本类型时，将自动重新调整合适的字体大小。您可以在文本属性中设置字体大小。',

	'propText': '文本详细信息', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': '文本属性', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': '字体大小',
	'textFontFamily': '字体系列',
	'textFontWeight': '字体粗细', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': '图像链接',
	'propMissingURL': '输入 URL',
	'propImgTop': '图像属性', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': '常规属性', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': '常规', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': '常规', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': '填充颜色', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': '文本颜色', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': '边框颜色',
	'propMaintainAxisScales': '保持轴刻度',
	'propShowItemLabel': '显示项标签',
	'propHideLegend': '隐藏图注',
	'propColorPalette': '调色板',
	'propLegendPosition': '图注位置',
	'propHideAxisTitleLabels': '隐藏轴名',
	'propLineColor': '折线图颜色',
	'propBubbleColor': '气泡颜色',
	'propInterpolation': '平滑线条',
	'propElementColor': '可视化元素颜色',
	'propSymbolShape': '符号形状',
	'propHeatScalePalette': '颜色顺序',
	'propHeatScalePalette_tooltipDarkerForLowerValue': '颜色越深，表示的值越小。',
	'propHeatScalePalette_tooltipDarkerForHigherValue': '颜色越深，表示的值越大。',
	'propImageDetails': '图像详细信息', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Web 页面详细信息', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': '媒体详细信息', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': '输入 URL 并按 Enter 键。',

	//Layout Properties
	'sectionName_positionAndStyle': '位置和样式',
	'propPositionLabel': '位置', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': '大小', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': '宽度',
	'propResizeHeight': '高度',
	'propRotateLabel': '旋转',
	'propRotateAngle': '角度', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': '图标的数量',
	'propScaleDescription': '选择图标的数量',
	'propScaleFew': '低',
	'propScaleDefault': '默认',
	'propScaleMany': '高',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': '此值必须是数字',

	'mediaAriaLabel': 'URL 输入',
	'dropdownAriaLabel' : '下拉列表',
	'ariaGroupLabel': '下拉列表类别：%{cateoryLabel}，项：%{itemLabel}。按“向下”键可展开。按“向上”和“向下”键可进行浏览，或按 ESCAPE 键折叠。',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': '上次刷新时间：%{timeInterval} 之前',
	'widgetTimer': '窗口小部件计时器',

	// Theme colors
	'transparent': '无颜色',
	'white': '白色',
	'lightGrey': '浅灰色',
	'grey': '灰色',
	'darkGrey': '深灰色',
	'black': '黑色',
	'lightBlue': '浅蓝色',
	'blue': '蓝色',
	'darkBlue': '深蓝色',
	'yellow': '黄色',
	'orange': '橙色',
	'lime': '酸橙色',
	'green': '绿色',
	'peach': '桃红色',
	'red': '红色',
	'violet': '紫罗兰色',
	'aqua': '浅绿色',
	'purple': '紫色',
	'plum': '紫红色',
	'gray10': '灰色 10',
	'gray20': '灰色 20',
	'gray30': '灰色 30',
	'gray50': '灰色 50',
	'gray60': '灰色 60',
	'gray70': '灰色 70',
	'gray80': '灰色 80',
	'gray90': '灰色 90',
	'gray100': '灰色 100',
	'blue50': '蓝色 50',
	'blue60': '蓝色 60',
	'blue70': '蓝色 70',
	'green40': '绿色 40',
	'green50': '绿色 50',
	'red50': '红色 50',
	'red60': '红色 60',


	//Theme Palette Label
	'paletteLabel': 'IBM 调色板 %{number}',
	'heatPaletteLabel': 'IBM 热点调色板 %{number}',
	'conditionalPaletteLabel': 'IBM 条件调色板 %{number}',
	'carbonPaletteXLight': 'Carbon X 细体',
	'carbonPaletteXDark': 'Carbon X 黑体',
	'carbonPalettePurple': '紫色',
	'carbonPaletteTeal': '蓝绿色',
	'carbonPaletteCyan': '青色',
	'carbonPaletteMagenta': '品红色',
	'carbonPalettePurpleTeal': '紫蓝绿色',
	'carbonPaletteCyanMagenta': '青品红色',
	'carbonPaletteGreenRed': '青红色',
	'carbonPaletteGreenYellowRed': '绿黄红色',
	'carbonPalettePurpleTealConvergent': '紫蓝绿色聚合',
	'carbonPaletteCyanMagentaConvergent': '青品红色聚合',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM 浅色调色板',
	'userPaletteColor_defaultTheme': 'IBM 默认调色板',
	'userPaletteColor_darkTheme': 'IBM 深色调色板',

	// Dashboard
	'propDashboardBackgroundColor': '背景色',
	'propLayoutPositioning': '布局定位',
	'propLayoutRelative': '相对',
	'propLayoutAbsolute': '绝对值',
	'propLayoutPositioningCoachmarkTitle': '选择布局样式',
	'propLayoutPositioningCoachmarkContent': '在相对布局中，窗口小部件的大小和位置会调整以适应屏幕。在绝对布局中，窗口小部件完全按您在视图中调整的大小和放置位置来显示，与屏幕大小无关。',
	'gridText': '显示网格',
	'snapText': '对齐网格',
	'snapObjectsText': '对齐对象',
	'fitPageText': '适合页面',
	'gridLabel': '网格',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': '页面大小',
	'propPageSizePresetAriaLabel': '页面大小预设',
	'propPageSizePreset': '预置',
	'propPageSizePresetCustom': '自定义',
	'propPageSizePreset16x9': '屏幕 16:9',
	'propPageSizePreset4x3': '屏幕 4:3',
	'propPageSizePresetInfographic': '信息图',
	'propPageSizeWidth': '宽度',
	'propPageSizeHeight': '高度',
	'propPageSizeWidthAriaLabel': '页面大小宽度',
	'propPageSizeHeightAriaLabel': '页面大小高度',
	'propPageSizeAdjustedMessage': '页面大小已增大，因为条目低于最小值，或者不适应仪表板。',
	'propTabShow': '显示选项卡',
	'propShowTabsInPreview': '在预览中显示选项卡',
	'multilingualDashboardsLabel': '语言',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- 默认值',
	'multilingualDashboardsAddLinkText': '添加其他语言',
	'multilingualDashboardsSelect': '选择',
	'multilingualDashboardsButtonLabel': '添加',
	'multilingualDashboardTranslationMode': '您现在处于翻译方式 (%{currentLanguage})',
	'multilingualDashboardTranslationDone': '完成',
	'multilingualDashboardRemainingStrings': '还剩 %{numTranslationsLeft} 个翻译',
	'multilingualDashboardRemainingString': '还剩 1 个翻译',
	'multilingualDashboardsSetDefault': '设置默认语言',
	'multilingualDashboardIconMore': '语言 %{currentLanguage} 的更多操作',
	'multilingualDashboardIconTranslatableArea': '可翻译区域',
	'multilingualDeleteTitle': '删除语言',
	'multilingualDeleteLanguageWarning': '确定要删除语言“%{language}”吗？',
	'multilingualSelectLanguage': '选择语言',
	'confirmLayoutStyleUpgradeTitle': '应用于所有选项卡',
	'confirmLayoutStyleUpgrade': '是否将此布局样式应用于仪表板中的所有选项卡？',

	//Tabs
	'tabDeleteDialogPrimaryButton': '删除',
	'tabDeleteDialogTitle': '删除此选项卡？',
	'tabDeleteDialogMessage': '此选项卡上的所有内容也会删除。',

	// Vis widget
	'propVisTypeReturn': '可视化类型',
	'propVisDetails': '详细信息',

	// Alignment picker
	'propAlignPickTop': '顶部对齐',
	'propAlignPickRight': '右侧对齐',
	'propAlignPickBottom': '底部对齐',
	'propAlignPickLeft': '左侧对齐',
	'propAlignPickCenter': '居中对齐',
	'propAlignPicker': '对齐',

	// Toolbar picker
	'propToolbarPickBold': '粗体',
	'propToolbarPickUnderline': '下划线',
	'propToolbarPickItalic': '斜体',
	'propToolbarPickJustifyLeft': '左侧对齐',
	'propToolbarPickJustifyCenter': '居中对齐',
	'propToolbarPickJustifyRight': '右侧对齐',
	'propToolbarPickJustify': '对齐',

	'propList': '列表',
	'propOrderedList': '排序列表',
	'propUnorderedList': '未排序列表',

	// Symbol shapes
	'propCircle': '圆圈',
	'propTriangle': '三角形',
	'propSquare': '正方形',
	'propRect': '矩形',
	'propStar': '星形',
	'propCross': '十字',
	'propPlus': '加号',
	'propPoly': '多边形',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': '左侧',
	'propRight': '右侧',
	'propTop': '顶部',
	'propBottom': '底部',

	// Interpolation options
	'propSmooth': '平滑',
	'propStraight': '直线',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': '列表', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': '左移', // screen reader
	'srWidgetMoveUp': '上移', // screen reader
	'srWidgetMoveRight': '右移', // screen reader
	'srWidgetMoveDown': '下移', // screen reader

	// widget resize
	'srWidgetResizeBigger': '按比例增大大小', // screen reader
	'srWidgetResizeSmaller': '按比例减小大小', // screen reader
	'srWidgetResizeBiggerV': '垂直增大大小', // screen reader
	'srWidgetResizeSmallerV': '垂直减小大小', // screen reader
	'srWidgetResizeBiggerH': '水平增大大小', // screen reader
	'srWidgetResizeSmallerH': '水平减小大小', // screen reader

	// widget rotate
	'srWidgetRotateCW': '顺时针旋转', // screen reader
	'srWidgetRotateCCW': '逆时针旋转', // screen reader

	// Recommended types
	'visChange': '更改可视化',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': '可视化',
	'chartLabel': '%{chartName} 图表',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': '按 F12 以在窗口小部件中浏览。',
	'f10KeyDescription': '按 F10 键以启动窗口小部件焦点视图',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '值为 %{value} 的 %{label}',

	'shapeColorLabel': '形状颜色',
	'showLegendLabel': '显示图注',

	//Webpage
	'webpageWidgetTitle': 'Web 页面窗口小部件',
	'webpagePasteLink': '粘贴 URL 并按 Enter 键以保存。',
	'propWebpageLink': 'Web 页面 URL',
	'propWebpageTitle': 'Web 页面标题',
	'propWebpageTitleDescription': 'Web 页面的标题',
	'webpageUrl': 'Web 页面 URL',
	'noWebpageSelected': '未选择 Web 页面',
	'enterWebpageUrl': '在此处输入 Web 页面 URL',
	'propWebpageTop': 'Web 页面属性', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': '缺少 Web 页面 URL。',
	'webpageUrlValidationError': 'Web 页面 URL 无效。',
	'webpageHttpValidationError': 'Web 页面必须使用 HTTPS 链接进行访问。',
	'webpageInvalidDomainError': 'Web 页面 URL 指向尚未由管理员核准的域。管理员核准的域为“%{domains}”。',

	//VizState
	'vzErrorLoading': '无法装入可视化',
	'vzErrorLoadingMissingData': '无法装入可视化，缺少上下文数据',

	//Media (Video / Audio)
	'mediaWidgetTitle': '介质窗口小部件',
	'mediaPasteLink': '粘贴 URL 并按 Enter 键以保存。',
	'mediaUrl': '媒体 URL',
	'noMediaSelected': '未选择媒体',
	'enterMediaUrl': '在此处输入媒体 URL',
	'videoHeight': '高度：',
	'videoWidth': '宽度：',
	'propMediaLink': '媒体链接',
	'propMediaTitle': '媒体标题',
	'propMediaTitleDescription': '媒体的标题',
	'propMediaTop': '媒体属性', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': '缺少媒体链接 URL。',
	'mediaUrlValidationError': '媒体文件 URL 无效。',
	'mediaUnknownValidationError': '不支持此类型媒体。',
	'mediaHttpValidationError': '媒体文件必须使用 HTTPS 链接进行访问。',
	'mediaInvalidDomainError': '媒体文件 URL 指向尚未由管理员核准的域。管理员核准的域为“%{domains}”。',

	// Properties pane
	'commonPropertiesLabel': '属性', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': '数据集',
	'dataViewsLabel': '视图',
	'columnQuality': '数据质量',
	'columnProperties': '数据属性',

	'dataQuality': '数据质量',
	'dataQualityRowCount': '行数',
	'dataQualityDistribution': '分布',
	'dataRowLabel': '数据',

	// Modelling UI
	'typeColumn': '类型',
	'modellingColumnType': '类型',
	'modellingColumnAggregation': '聚集',
	'modellingColumnUsage': '使用量',
	'modellingColumnSort': '排序',
	'modellingColumnFormat': '格式',
	'modellingColumnCategory': '类别',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': '正在装入...',

	'modellingProcessing': '正在处理...',
	'modellingImport': '导入',
	'modellingReimport': '重新导入',
	'modellingDatasourceTitle': '数据源',
	'modellingImportStartedTitle': '开始导入',
	'modellingImportStartedText': '导入数据可能需要一些时间。\n\n（您可以在数据导入时创建视图。）',
	'importDatasourceTitle': '连接',
	'dropHere': '放至此处以创建新数据源...',
	'browseButton': '浏览',
	'errorNoData': '没有要处理的数据。',
	'errorNoFile': '没有要上载的文件。',
	'errorUploadFailed': '无法上载。',
	'uploadSucceessful': '上载成功',
	'del_datasourceTitle': '删除数据集',
	'del_datasourceMsg': '确定要删除“%{name}”吗？',
	'modellingFileUpdate': '更新',
	'modellingFileUpdateTitle': '更新数据集',
	'modellingFileUpdateDescription': '是否想要更新“%{name}”？',
	'modellingFileUpdatingTitle': '正在更新“%{name}”',
	'modellingUpdateStartedTitle': '更新导入已开始',
	'modellingUpdateStartedText': '更新数据可能需要一些时间。\n\n（您可以在数据更新时创建视图。）',
	'modellingErrorImportUploadNoFile': '没有要上载的文件。',
	'modellingErrorImportUploadFailed': '无法上载。',
	'modellingErrorImportUploadInvalidType': '文件类型无效。',
	'modellingErrorImportUploadTableFailed': '无法获取表。',
	'modellingIntentResultsTitle': '选择提议的数据集以使用',
	'modellingColumnViewRelationships': '查看相关表',
	'modellingTableRelatedTables': '与“%{name}”相关的表',
	'modellingTable': '%{name} - 表',
	'modellingColumnIncludedInDataSet': '已添加',
	'modellingDataSet': '数据集',
	'modellingViewInDataSet': '查看数据集',
	'modellingViewRelatedTables': '查看相关表',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': '找不到相关表',

	'modellingValidatingDataset': '正在验证...',
	'datasetFinishedRefreshing': '数据集 %{datasetName} 已刷新。',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': '解析联接路径：',
	'modellingJoinColumns': '定义表的联接路径：%{name}',
	'modellingJoinToTable': '联接到表：%{name}',

	// Data Quality
	'excluded': '已排除',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': '过滤器',
	'modellingColumnSortNone': '清除排序',
	'modellingColumnSortAsc': '按升序排序',
	'modellingColumnSortDesc': '按降序排序',
	'modellingColumnRemove': '移除此列',

	// Import File Browser
	'dropboxPageTitle': '新建 Dropbox 连接',
	'sizeColumn': '大小',

	//Modelling Column Property Values
	'dataType_string': '字符串',
	'dataType_date': '日期',
	'dataType_integer': '整数',
	'dataType_double': '双精度数',
	'dataType_float': '浮点',
	'dataType_boolean': '布尔值',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': '计数',
	'defaultAggregation_countdistinct': '计数差异',
	'defaultAggregation_max': '最大值',
	'defaultAggregation_min': '最小值',
	'defaultAggregation_avg': '平均值',
	'defaultAggregation_sum': '总和',
	'defaultAggregation_auto': '自动 (%{aggregationType})',

	'type_fact': '资料',
	'type_attribute': '属性',

	'defaultSort_none': '不排序',
	'defaultSort_asc': '按升序排序',
	'defaultSort_desc': '按降序排序',

	'category_none': '无',
	'category_location': '位置',
	'category_monetary': '货币',
	'category_time': ' 时间',

	// Root menu
	'rootMenuTitle': '主菜单',

	'errorMessageTitle': '错误',
	'errorMessageDetails': '详细信息：',
	'errorMessageTitleAssetAlreadyExists': '资产已存在',

	'defaultTabTitle': '选项卡 %{index}',
	'tabAddBtnTitle': '添加新选项卡',

	'unsupportedConditionalFormattingEncountered': '条件格式化不再应用于某些列。',


	// Homepage View
	'nameColumn': '名称',
	'creatorColumn': '创建者',
	'creationDateColumn': '创建日期',
	'versionColumn': '版本',
	'modifiedColumn': '上次修改时间',

	'filterBy': '过滤项',
	'allFilter': '所有项',
	'createdByMeFilter': '由我创建',
	'sharedWithMeFilter': '与我共享',
	'favoritesFilter': '我的收藏夹',
	'recentsFilter': '最近已添加',
	'sortBy': '排序依据',

	// Sort Menu
	'sortModified': '修改时间',
	'sortUpdated': '已更新',
	'sortName': '名称',

	'viewAs': '查看方式',
	'thumbnailsView': '作为缩略图查看',
	'listView': '作为列表查看',
	'createMenu': '创建',
	'newAppItem': '仪表板',
	'newDataSet': '数据集',

	'menuSelectionState_a11y': '“%{item}”选择器设置为“%{selectedItem}”',

	'unableToShareItem': '无法共享项“%{item}”。',
	'toastFetchingContent': '正在获取更多内容...',
	'unableToGetData': '无法获取内容。',
	'unableToFavorite': '无法更改收藏夹状态。',
	'hpErrorMissingRequiredOptions': '缺少所需初始化选项',
	'unableToOpenBoard': '无法打开“%{name}”。',
	'unableToDuplicateBoard': '无法复制“%{name}”。',
	'unableToCreateBoard': '无法创建“%{name}”。',
	'unableToCreateBoardNameConflict': '已存在具有相同名称的资产。',

	// DataSet Detail View
	'status': '状态',
	'numberOfRows': '行数',
	'importWarnings': '警告',
	'lineNumbers': '行数',
	'excerptFromSource': '摘录',
	'reason': '原因',
	'numberOfRowsDropped': '已删除的行数',
	'oneRowDropped': '已删除 1 行',

	// Type Menu
	'typeMenuLabel': '类型',
	'dashboardsLabel': '仪表板',
	'datasetsLabel': '数据集',
	'storiesLabel': '案例',
	'allLabel': '所有类型',

	// Board Page View App Bar
	'datasets': '数据集',
	'settings': '属性',
	'add': '添加',
	'widgets': '窗口小部件',
	'dashboardProperties': '仪表板属性',
	'searchPanel' : '搜索',
	'pins': '收集',
	'pinsOld': '我的置顶',
	'pinsDateFilterHeading' : '置顶的日期',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} 个置顶|||| %{smart_count} 个置顶',
	'pinSearch': '搜索',
	'pinSearchOld': '搜索置顶',
	'pinListView': '列表视图',
	'pinIconView': '图标视图',
	'pinRemove': '移除',
	'pinCreate': '创建',
	'pinDeleteError': '无法从集合中删除一个或多个资产。请稍后重试。',
	'pinDeleteErrorOld': '无法删除一个或多个置顶。请稍后重试。',
	'pinRetrieveError': '无法检索一个或多个置顶。请稍后重试。',
	'NoPinsCollected': '无置顶的可视化',
	'pinDeletedToast': '已移除置顶',
	'pinAddedToast': '已成功将置顶添加到“我的置顶”',
	'pinningToast': '正在处理置顶...',
	'pinDateFilter': '日期过滤器',
	'pinDateFilterAll': '全部',
	'pinDateFilterToday': '今天',
	'pinDateFilterYesterday': '昨天',
	'pinDateFilterPastWeek': '上一周',
	'pinDateFilterPastMonth': '上个月',
	'pinDateFilterEarlier': '更早',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': '编辑标题',
	'toolbarActionSort': '排序',
	'toolbarActionSortAscending': '按升序排序',
	'toolbarActionSortDescending': '按降序排序',
	'toolbarActionSortAuto': '自动 (%{sortOrder})',
	'toolbarActionFormat': '格式化数据',
	'toolbarActionFormatAbbreviation': '缩写',
	'toolbarActionFormatNone': '自动',
	'toolbarActionFilter': '过滤器',
	'toolbarActionTopBottom': '顶部或底部',
	'toolbarActionAddShape': '添加形状',
	'toolbarActionRmvShape': '除去形状',
	'toolbarActionToggleShapeDrop': '信息图形状',
	'toolbarActionToggleShapeDropTitle': '创建信息图',
	'toolbarActionToggleShapeDropText': '将形状拖至此字段以创建信息图。',
	'toolbarActionAggregationType': '汇总',
	'toolbarDeleteActionText': '除去列',
	'toolbarActionFilterLocalKeepSelected': '保留',
	'toolbarActionFilterLocalExcludeSelected': '排除',
	'toolbarActionFilterAllKeepSelected': '过滤器',
	'toolbarActionSimpleCalculation': '简单计算',
	'toolbarActionDrillBack': '返回',
	'toolbarActionDrillUp': '向上钻取',
	'toolbarActionDrillDown': '向下钻取',
	'toolbarActionNavigate': '导航',
	'toolbarActionCreateFilterGroup': '新建连接',
	'toolbarActionDisconnectFilterGroup': '中断所有链接',
	'toolbarActionLinkFilterGroup': '添加到现有连接',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': '添加',
	'sidebarMultiselect': '在多个选择中切换',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '已选择 %{count} 项',

	'multiselectWithTotalMsg': '第 %{count} 项（共 %{total} 项）',
	'sidebarGoBack': '返回',

	//DataSet pane
	'errorLoadingDataSets': '无法装入此数据集',
	'errorLoadingDataSetMetaData': '无法装入此数据集',
	'dataSetPaneLastUpdated': '上次更新时间：%{date}',
	'dataSetPaneDateUnknown': '未知',
	'sourcePaneLabel': '所选源',
	'addSourceLabel': '添加源',
	'find_label': '查找',
	'navigationPathsLabel': '导航路径',

	//widgetlist
	'errorLoadingWidgetList': '无法装入对象。',
	'errorLoadingThemeFile': '无法装入主题定义',
	'errorLoadingLayoutFile': '无法装入视图。',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': '无法装入可用可视化定义',

	'dwErrorLoadingVisualizationNotFound': '无法装入对象，因为此对象缺少可视化定义',
	'dwErrorLoadingVisualizationListNotFound': '无法装入可视化。',
	'dwErrorRunningQuery': '无法在数据集 %{datasetName} 中检索数据。',
	'dwErrorGeoData': '在地图中显示地理数据时遇到问题。请选择其他可视化类型。',
	'dwPromptSignonCancelWarning': '此可视化的数据不可用。请提供正确凭证。',
	'dwErrorMissingDataset': '无法装入可视化，因为其关联的数据集“%{datasetName}”不可用。',
	'dwErrorRenderingVisualization': '无法装入此可视化。',
	'dwErrorVisualizationTooSmall': '可视化过小，无法显示其所包含的数据。请放大可视化或限制其包含的数据。',
	'aria_label_datatable': '数据表',
	'aria_key_navi_datatable_desc': '使用方向键可浏览至每个单元格。按 Control+Home 键可移至第一行，按 Control+End 键可移至最后一行。',
	'geomapUnrecognizedLocations': '无法识别的位置：',
	'geomapAmbiguousLocations': '不明确的区域：',

	// custom widget
	'customWidget': '自定义窗口小部件',
	'customWidgetsTitle': '自定义窗口小部件',
	'noCustomWidgets': '无自定义窗口小部件',

	// Action names
	'toggleContextBar': '切换上下文栏',
	'delete': '删除',
	'share': '共享',
	'unshare': '取消共享',
	'rename': '重命名',
	'close': '关闭',
	'duplicate': '重复',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': '重试',

	'changeTemplate': '更改模板',

	// Aggregation Types
	'sum': '总和',
	'count': '计数',
	'countdistinct': '计数差异',
	'avg': '平均值',
	'min': '最小值',
	'max': '最大值',
	'custom': '自定义',
	'calculated': '已计算',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '更改百分比',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': '可视化条件...',
	'QuickAddResultsHeader': '数据可视化',
	'NoQuickAddResults': '没有与您意向的匹配项。创建新的数据集？',
	'NoQuickAddResultsRetry': '找不到任何匹配项。请使用其他项重试。',
	'templateWidgetTitle': '模板',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '（空白）',

	'nullValueContent': '（无值）',
	'nullValueText': '空值',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': '文本过滤器 - %{columnName}',

	'textFilterSelectTab': '选择',

	'textFilterConditionTab': '设置条件',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': '没有可用项。',

	'textFilterEquals': '等于',
	'textFilterContains': '包含',
	'textFilterBeginsWith': '开头为',
	'textFilterEndsWith': '结尾为',
	'textFilterDoesNotEqual': '不等于',
	'textFilterDoesNotContain': '不包含',
	'textFilterDoesNotBeginWith': '开头不是',
	'textFilterDoesNotEndWith': '结尾不是',
	'textFilterSampleText': '例如：A',

	'textFilterAndButton': '和',
	'textFilterOrButton': '或',

	'dateFilterMessage': '选择一系列日期',
	'dateRangeControlRegionLabel': '日期范围过滤器 - %{columnName}',
	'dateFilterRangeOption': '范围选项',
	'dateFilterDateLabel': '日期',
	'dateFilterBlank': '（空白）',
	'dateFilterBefore': '之前',
	'dateFilterAfter': '之后',
	'dateFilterBetween': '两者之间',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': '日期',
	'dateIncludeBlankLabel': '包括空白日期',

	'timeTitle': ' 时间',
	'timeFilterMessage': '选择一系列时间',
	'dateTimeFilterMessage': '选择一系列日期和时间',

	'topbottomNumberOfResultsLabel': '结果数',
	'topbottomPercentLabel': '百分比',
	'topbottomNumberOfResultsLimit': '介于 %{lower} 和 %{higher} 之间',
	'topbottomSelectOption': '顶部或底部选项',
	'topbottomOptionLabel': '显示',
	'searchByLabel': '按',
	'searchNoMatches': '找不到任何匹配项',
	'topbottomRankColumnLabel': '将排名列添加到表中',
	'topbottomNone': '无',
	'topCount': '最高计数',
	'topPercent': '最高百分比',
	'bottomCount': '最低计数',
	'bottomPercent': '最低百分比',
	'topbottomSearchColumn': '查找列',
	'searchColumnAriaLabel': '查找列。输入要搜索的列的名称，然后使用向下箭头在列表中查找该列',
	'rankColumnLabel': '排名 (%{columnLabel})',
	'topbottomClearLabel': '清除',

	'rangeFilterControlRegionLabel': '范围过滤器 - %{columnName}',

	// Slider
	'sliderRegionLabel': '滑块控件，使用向右和向左箭头来移动滑块手柄',
	'sliderHandleLabel': '滑块手柄',
	'a11ySliderHandleLabel': '滑块手柄 %{sliderValue}',
	'sliderInputLabel': '值',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': '此可视化中使用的某些数据集项不可用。',
	'datasetItemUnavailable': '此数据集项不可用',

	//Authoring topBottom
	'topOperator': '顶部',
	'bottomOperator': '底部',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value}（按 %{columnLabel}）',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': '仅限此对象',
	'deleteTopBottom': '删除最高或最低计数',
	'editTopBottom': '编辑最高或最低计数',
	'deleteDrillState': '删除当前钻取状态',
	'ariaDeleteDrillStateLabel': '按 ENTER 键以编辑最高或最低计数。',
	'drillUpStateTitle': '向上钻取',
	'drillDownStateTitle': '向下钻取',
	'ariaEditTopBottomLabel': '按 ENTER 键以编辑最高或最低计数。',
	'ariaDeleteTopBottomLabel': '按 DELETE 键以删除最高或最低计数。',

	// Authoring filtering
	'dimFilterIn': '包含：%{in}',
	'dimFilterNotIn': '排除：%{out}',
	'measureFilterBetween': '介于 %{lowerBound} 和 %{upperBound} 之间',
	'measureFilterNotBetween': '不介于 %{lowerBound} 和 %{upperBound} 之间',
	'gtFilter': '%{lowerBound} 之后',
	'ltFilter': '%{upperBound} 之前',
	'notGtFilter': '不在 %{lowerBound} 之后',
	'notLtFilter': '不在 %{upperBound} 之前',
	'localFilterTitle': '仅限此对象',
	'globalFilterTitle': '所有对象',
	'deleteFilter': '删除过滤器',
	'editFilter': '编辑过滤器',
	'ariaEditFilterLabel': '按 ENTER 键以编辑过滤器。',
	'ariaDeleteFilterLabel': '按 DELETE 键以删除过滤器。',

	// Prompts
	'ariaEditPrompt': '按 ENTER 键以更改提示值',

	'moreDataIndicator': '数据已在 %{threshold} 项处被剪切。应用过滤器以显示更少内容。',

	// data point filtering
	'dataPointFilterTitle': '数据点',
	'dataPointFilterIncludeSummary': '已包含 %{valueCount} 个数据点',
	'dataPointFilterExcludeSummary': '已排除 %{valueCount} 个数据点',

	// DB2 connection page
	'db2Database': 'Db2 数据库 (%{jdbcConnection})',
	'db2Title': '连接到 IBM Db2',

	// Database
	'databaseConnectionMessage': '提供数据库连接详细信息：',
	'connectionString': '数据库连接字符串',
	'databaseCredentials': '凭证：',
	'databaseUserName': '用户名',
	'databasePassword': '密码',
	'databaseConnect': '连接',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': '输入搜索项：',
	'twitterKeyword': '关键字',
	'twitterSearch': '搜索',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'Db2',

	'workbookCreateFailed': '无法创建视图：%{error}\n操作失败：%{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': '窗口小部件过滤器',
	'missingColumn': '缺少：%{columnLabel}',
	'missingFiltering': '缺少对以下列标识的过滤器：',
	'heatByLabel': '热度依据',
	'evColumns': '列数',
	'evLocalFilters': '本地过滤器',
	'evExpand': '展开',
	'evFilterTooltip': '过滤器',
	'evAdd': '添加列',

	// Navigation View
	'navigationBack': '返回',

	// Pinning
	'contentPinFail': '无法收集内容。请稍后重试。',
	'contentPinFailOld': '无法将内容置顶。请稍后重试。',

	// Layouts
	'dropZoneLabel': '放在此处以最大化',

	//Share
	'shareDefaultPageTitle': '页面 %{index}',

	'nextPage': '下一页',
	'previousPage': '上一页',

	'assetAssembly': '视图',

	'toolbar_save': '保存',
	'brgr_saveAs': '另存为',
	'brgr_refresh': '刷新',

	// Save
	'saving': '正在保存...',
	'save_success': '您的视图已保存。',
	'save_failure': '很抱歉。您的视图无法保存。请稍后重试。',
	'dashboard_save_success': '您的仪表板已保存。',

	'geminiLeave': '您将退出 IBM Watson Analytics。',

	'warning': '警告',
	'missingDataSetData': '此数据集的数据不可用。请刷新此数据集，或联系管理员以获取对该源的访问权。',

	// Calculations
	'error_calculation_in_use': '所选计算正在使用中，无法删除。',

	'resize': '调整大小',
	'rotate': '旋转',
	'moveHandle': '移动窗口小部件',
	'expandHandle': '展开',
	'panHandle': '平移',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': '导航至',

	// Slide out titles
	'shapeSlideoutTitle': '形状',
	'textSlideoutTitle': '文本',
	'mediaSlideoutTitle': '媒体',
	'visualizationSlideoutTitle': '可视化',

	// Board Model Dialog Messages
	'invalidJSONResponse': '提供的 JSON 无效。请参阅错误日志以获取更多信息。',

	// Widget type labels
	'shape_label': '形状',
	'image_label': '图像',
	'data_label': '图表',
	'media_label': '媒体',
	'text_label': '文本',
	'embedMedia_label': '媒体',
	'youtube_label': 'YouTube 视频',
	'webpage_label': 'Web 页面',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': '形状',
	'noExtraText_shape_numbered': '形状 (%{number})',
	'few_shape': '包含 %{count} 个形状的组',
	'many_shape': '包含 %{count} 个形状的组',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} 图像',
	'one_image_numbered': '%{text} 图像（%{number} 个）',
	'noExtraText_image': '图像',
	'noExtraText_image_numbered': '图像（%{number} 个）',
	'few_image': '包含 %{count} 个图像的组',
	'many_image': '包含 %{count} 个图像的组',
	'noExtraText_text': '空文本框',
	'noExtraText_text_numbered': '空文本框（%{number} 个）',
	'few_text': '包含 %{count} 个文本框的组',
	'many_text': '包含 %{count} 个文本框的组',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values}（按 %{row_level1} 和 %{column_level1} 交叉表）',
	'crosstab_opt_mapping_numbered': '%{values}（按 %{row_level1} 和 %{column_level1}（%{number} 个）交叉表）',
	'crosstab_has_mapping': '%{values}（按 %{row_level1} 交叉表）',
	'crosstab_has_mapping_numbered': '%{values}（按 %{row_level1}（%{number} 个）交叉表）',
	'crosstab_no_mapping': '空交叉表',
	'crosstab_no_mapping_numbered': '空交叉表（%{number} 个）',
	'crosstab_named': '%{name} 交叉表',
	'crosstab_named_numbered': '%{name} 交叉表（%{number} 个）',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} 表',
	'JQGrid_has_mapping_numbered': '%{grid_cols} 表（%{number} 个）',
	'JQGrid_no_mapping': '空表',
	'JQGrid_no_mapping_numbered': '空表（%{number} 个）',
	'JQGrid_named': '%{name} 表',
	'JQGrid_named_numbered': '%{name} 表（%{number} 个）',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} 层级',
	'hierarchy_has_mapping_numbered': '%{level1} 层级（%{number} 个）',
	'hierarchy_no_mapping': '空层次结构',
	'hierarchy_no_mapping_numbered': '空层级（%{number} 个）',
	'hierarchy_named': '%{name} 层级',
	'hierarchy_named_numbered': '%{name} 层级（%{number} 个）',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} 地图',
	'map_has_mapping_numbered': '%{categories} 地图（%{number} 个）',
	'map_no_mapping': '空地图',
	'map_no_mapping_numbered': '空地图（%{number} 个）',
	'map_named': '%{name} 地图',
	'map_named_numbered': '%{name} 地图（%{number} 个）',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} 摘要值',
	'summary_has_mapping_numbered': '%{actual} 摘要值（%{number} 个）',
	'summary_no_mapping': '空摘要值',
	'summary_no_mapping_numbered': '空摘要值（%{number} 个）',
	'summary_named': '%{name} 摘要值',
	'summary_named_numbered': '%{name} 摘要值（%{number} 个）',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual}（按 %{sparkline.time} KPI）',
	'kpi_opt_mapping_numbered': '%{actual}（按 %{sparkline.time} KPI（%{number} 个））',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI（%{number} 个）',
	'kpi_no_mapping': '空 KPI',
	'kpi_no_mapping_numbered': '空 KPI（%{number} 个）',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI（%{number} 个）',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} 信息图',
	'infographicSummary_has_mapping_numbered': '%{actual} 信息图（%{number} 个）',
	'infographicSummary_no_mapping': '空信息图',
	'infographicSummary_no_mapping_numbered': '空信息图（%{number} 个）',
	'infographicSummary_named': '%{name} 信息图',
	'infographicSummary_named_numbered': '%{name} 信息图（%{number} 个）',
	'noExtraText_youtube': 'YouTube 视频',
	'noExtraText_youtube_numbered': 'YouTube 视频（%{number} 个）',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube 视频',
	'one_youtube_numbered': '%{text} YouTube 视频（%{number} 个）',
	'few_youtube': '包含 %{count} 个 YouTube 视频的组',
	'many_youtube': '包含 %{count} 个 YouTube 视频的组',
	'noExtraText_embedMedia': '媒体链接',
	'noExtraText_embedMedia_numbered': '媒体链接（%{number} 个）',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} 媒体链接',
	'one_embedMedia_numbered': '%{text} 媒体链接（%{number} 个）',
	'few_embedMedia': '包含 %{count} 个媒体链接的组',
	'many_embedMedia': '包含 %{count} 个媒体链接的组',
	'noExtraText_media': '媒体',
	'noExtraText_media_numbered': '媒体（%{number} 个）',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} 媒体',
	'one_media_numbered': '%{text} 媒体（%{number} 个）',
	'few_media': '包含 %{count} 个媒体的组',
	'many_media': '包含 %{count} 个媒体的组',
	'noExtraText_webpage': 'Web 页面',
	'noExtraText_webpage_numbered': 'Web 页面（%{number} 个）',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} Web 页面',
	'one_webpage_numbered': '%{text} Web 页面（%{number} 个）',
	'few_webpage': '包含 %{count} 个 Web 页面的组',
	'many_webpage': '包含 %{count} 个 Web 页面的组',
	'one_unknown': '对象',
	'one_unknown_numbered': '对象（%{number} 个）',
	'few_unknown': '包含 %{count} 个对象的组',
	'many_unknown': '包含 %{count} 个对象的组',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': '下一步',
	'previous': '上一页',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': '当前导航组为 %{navigation_group_name}',

	//Page Context
	'filterBlank': '（空白）',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': '无法装入过滤器值',
	'editTimelineHighlight': '编辑突出显示',

	'filterDockChevronLeft': '滚动浏览数据',
	'filterDockChevronRight': '滚动浏览数据',
	'expand': '展开',
	'collapse': '折叠',

	//Reset Dashboard
	'dashboardResetTitle': '重置仪表板',
	'dashboardResetMessage': '确定要重置应用于此仪表板的所有更改吗？',
	'dashboardResetToast': '仪表板已重置。',

	//Generate PDF
	'buildingPDF': '正在构建 PDF...',
	'exportPDF': '导出为 PDF',
	'pageSize': '页面大小',
	'orientation': '方向',
	'filtersPresentPDF': '应用于前一页上可视化的过滤器：',
	'errorPDF': '无法生成 PDF。请刷新并重试。',
	'printPDFInfo': '查看文档',
	'pdfWidget': '窗口小部件',
	'includeFilters': '显示过滤器详细信息',
	'portrait': '纵向',
	'landscape': '横向',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': '仪表板已升级。请立即保存，以保持最佳性能。',

	'ariaFullScreenMessage': '按 Escape 键退出全屏',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} 压缩层级气泡图',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} 压缩层级气泡图（%{number} 个）',
	'LIVE_hierarchy_packed_bubble_no_mapping': '空压缩层级气泡图',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': '空压缩层级气泡图（%{number} 个）',
	'LIVE_hierarchy_packed_bubble_named': '%{name} 压缩层级气泡图',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} 压缩层级气泡图（%{number} 个）',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories}（按 %{values} Marimekko 图）',
	'LIVE_marimekko_has_mapping_numbered': '%{categories}（按 %{values} Marimekko 图（%{number} 个））',
	'LIVE_marimekko_no_mapping': '空 Marimekko 图表',
	'LIVE_marimekko_no_mapping_numbered': '空 Marimekko 图（%{number} 个）',
	'LIVE_marimekko_named': '%{name} Marimekko 图',
	'LIVE_marimekko_numbered': '%{name} Marimekko 图（%{number} 个）',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} 旭日图',
	'LIVE_sunburst_has_mapping_numbered': '%{values} 旭日图（%{number} 个）',
	'LIVE_sunburst_no_mapping': '空旭日图',
	'LIVE_sunburst_no_mapping_numbered': '空旭日图（%{number} 个）',
	'LIVE_sunburst_named': '%{name} 旭日图',
	'LIVE_sunburst_named_numbered': '%{name} 旭日图（%{number} 个）',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} 动因分析图表',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} 动因分析图表（%{number} 个）',
	'LIVE_decision_analysis_no_mapping': '空动因分析图表',
	'LIVE_decision_analysis_no_mapping_numbered': '空动因分析图表（%{number} 个）',
	'LIVE_decision_analysis_named': '%{name} 动因分析图表',
	'LIVE_decision_analysis_named_numbered': '%{name} 动因分析图表（%{number} 个）',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories}（按 %{columnValue} 和 %{lineValue} 柱形折线图）',
	'LIVE_line_column_opt_mapping_numbered': '%{categories}（按 %{columnValue} 和 %{lineValue} 柱形折线图（%{number} 个））',
	'LIVE_line_column_has_mapping': '%{columnValue} 和 %{lineValue} 柱形折线图',
	'LIVE_line_column_has_mapping_numbered': '%{categories}（按 %{columnValue} 和 %{lineValue} 柱形折线图（%{number} 个））',
	'LIVE_line_column_no_mapping': '空柱形折线图',
	'LIVE_line_column_no_mapping_numbered': '空柱形折线图（%{number} 个）',
	'LIVE_line_column_named': '%{name} 柱形折线图',
	'LIVE_line_column_named_numbered' : '%{name} 柱形折线图（%{number} 个）',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x}（按 %{y} 和 %{size} 气泡图）',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x}（按 %{y} 和 %{size} 气泡图（%{number} 个））',
	'LIVE_bubble_chart_no_mapping': '空气泡图',
	'LIVE_bubble_chart_no_mapping_numbered': '空气泡图（%{number} 个）',
	'LIVE_bubble_chart_named': '%{name} 气泡图',
	'LIVE_bubble_chart_named_numbered': '%{name} 气泡图（%{number} 个）',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} 项目符号图表',
	'LIVE_bullet_has_mapping_numbered': '%{actual} 项目符号图表（%{number} 个）',
	'LIVE_bullet_no_mapping': '空子弹图',
	'LIVE_bullet_no_mapping_numbered': '空项目符号图表（%{number} 个）',
	'LIVE_bullet_named': '%{name} 项目符号图表',
	'LIVE_bullet_named_numbered': '%{name} 项目符号图表（%{number} 个）',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': '此仪表板上的数据由以下项提供',
	'showFooterToggleButtonText': '显示页脚',
	'showFooterSectionText': '页脚'
});
